import { AbortedError } from 'src/common/api/extended-emerald-error';
import { EwicHostOffline, WicTenderRestriction } from 'src/common/helpers/error-code';
import XLRLogger from 'src/common/helpers/logger';
import { PaymentUsage, RefundUsage } from 'src/common/interfaces/dtos/IPreTenderAdd';
import { EpsData } from 'src/devices/payment/dtos/eps-data';
import { PmiStatusCodes } from 'src/devices/payment/pmi-status-codes-enums';
import { showEwicErrorModal } from './handle-ewic-error-handling';
import { processEFTTender } from './process-eft-tender';
import { EwicError } from './process-ewic-tender';
import { showTenderingError } from './show-tendering-error';

export const processAsyncEFTTender = async (
  epsData: EpsData,
  amountDue: number,
  amount?: number,
  usage?: PaymentUsage | RefundUsage,
  cashbackAmount?: number,
): Promise<void> => {
  await processEFTTender({
    epsData,
    amount: amount || amountDue,
    amountDue,
    usage,
    cashbackAmount,
  }).catch(async err => {
    XLRLogger.error({
      message: 'Error processing electronic payment',
      data: err,
      source: 'process-async-eft-tender',
    });

    // eWic has some special AC for tendering tab setting in showEwicErrorModal
    // so it throw EwicError to let caller skip set default tab

    if (err.code === WicTenderRestriction) {
      err.code = 'TendersOrderViolation';
      err.message = 'EwicSecondTender';
      await showEwicErrorModal(err);
      throw new AbortedError(EwicError);
    } else if (err.statusCode === PmiStatusCodes.HostOffline) {
      err.code = EwicHostOffline;
      await showTenderingError(err, epsData);
    } else if (err.code !== EwicError) {
      await showTenderingError(err, epsData);
    }

    throw new AbortedError(err.code);
  });
};
